var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "72263f057c4d18545b976e61c50bb227ae577558"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["disivo@disivo-sro"] = {
  id: "72263f057c4d18545b976e61c50bb227ae577558"
};